export default __webpack_public_path__ + "static/media/August_09.a7b06f4c.png";